import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AssinaturaModel } from 'app/model/assinatura/assinatura.model';
import { environment } from 'environments/environment';

@Injectable()
export class DocmentlistService {

  apiURL = environment.API;

  constructor(private httpClient: HttpClient) { }

  postDoc(assinatura: FormGroup) {
    return this.httpClient.post(this.apiURL + '/sign/createdocument',assinatura);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/docmentlist.service.ts